import * as React from "react"
import {
  LayoutDashboardIcon,
  AppWindowIcon,
  UsersIcon,
  CalendarIcon,
  BotIcon,
  BuildingIcon,
  ClipboardListIcon,
  MessageSquareIcon,
} from "lucide-react"

import { NavMain } from "@/components/nav-main"
import { NavUser } from "@/components/nav-user"
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar"
import logoImage from "/assets/logo-transparent.png"

interface User {
  id: number
  name: string
  email: string
  admin: boolean
}

interface AppSidebarProps extends React.ComponentProps<typeof Sidebar> {
  user: User
}

export function AppSidebar({ user, ...props }: AppSidebarProps) {
  const navMain: Array<{
    title: string
    url: string
    icon: typeof LayoutDashboardIcon
    activePattern?: string
  }> = [
    {
      title: "Dashboard",
      url: "/clinician/dashboard",
      icon: LayoutDashboardIcon,
      activePattern: "/clinician/dashboard",
    },
    ...(user.admin ? [
      {
        title: "Admin Console",
        url: "/admin/console",
        icon: AppWindowIcon,
        activePattern: "/admin/console",
      }
    ] : []),
    {
      title: "Patients",
      url: "/admin/patients",
      icon: UsersIcon,
      activePattern: "/admin/patients",
    },
    {
      title: "Appointments",
      url: "/admin/appointments",
      icon: CalendarIcon,
      activePattern: "/admin/appointments",
    },
    {
      title: "Messages",
      url: "/messages/conversations",
      icon: MessageSquareIcon,
      activePattern: "/messages",
    },
    ...(user.admin ? [
      {
        title: "Clinic Sites",
        url: "/admin/sites",
        icon: BuildingIcon,
        activePattern: "/admin/sites",
      },
      {
        title: "ICD-10 Codes",
        url: "/admin/icd10_codes",
        icon: ClipboardListIcon,
        activePattern: "/admin/icd10_codes",
      },
      {
        title: "AI Settings",
        url: "/admin/ai_settings",
        icon: BotIcon,
        activePattern: "/admin/ai",
      }
    ] : []),
  ]

  return (
    <Sidebar collapsible="icon" variant="inset" {...props}>
      <SidebarHeader>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton size="lg" asChild className="hover:bg-transparent active:bg-transparent data-[active=true]:bg-transparent">
              <a href="/dashboard">
                <img
                  src={logoImage}
                  alt="Breakthrough Health"
                  className="h-10 w-auto"
                />
                <div className="grid flex-1 text-left text-sm leading-tight">
                  <span className="truncate font-semibold">Breakthrough Health</span>
                </div>
              </a>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarHeader>
      <SidebarContent>
        <NavMain items={navMain} />
      </SidebarContent>
      <SidebarFooter>
        <NavUser user={user} />
      </SidebarFooter>
    </Sidebar>
  )
}
